import EquipeCard from "../EquipeCard/equipe-card";
import styles from "./equipe-section.module.css";
import RodrigoCard from "../../../images/_finais/imageCard-RodrigoRibeiro_compress.webp";
import MiriamCard from "../../../images/_finais/Foto-Miriam_compress.webp";
// import KarlyseCard from "../../../images/_finais/Foto-Karlyse_compress.webp";

interface IProps {
  onHandlePages: any;
}

const EquipeSection = ({ onHandlePages }: IProps) => {
  return (
    <section className={styles.equipe_section}>
      <div className={styles.equipe_div}>
        <div className={styles.title_div}>
          <h2 className={styles.equipe_title}>EQUIPE</h2>
          <span className={styles.line}></span>
        </div>
        <div className={styles.equipe_cards_div}>
          {/* <EquipeCard
            image={KarlyseCard}
            name="Karlyse Claudino Belli"
            cargo="Sócia-diretora"
            onHandlePages={onHandlePages}
            url="/equipe/karlyse-claudino-belli"
          /> */}
          <EquipeCard
            image={MiriamCard}
            name=" Miriam A. Zago Marcolino"
            cargo="Sócia-diretora"
            onHandlePages={onHandlePages}
            url="/equipe/miriam-zago-marcolino"
          />
          <EquipeCard
            image={RodrigoCard}
            name="Dr. Rodrigo Ribeiro"
            cargo="Sócio-diretor"
            onHandlePages={onHandlePages}
            url="/equipe/dr-rodrigo-antonini-ribeiro"
          />
        </div>
      </div>
    </section>
  );
};

export default EquipeSection;
